import React, { useRef, useState } from "react"
import { Col, Row, CardTitle, Label, Input, Button } from "reactstrap"

import ArrowDown from "../../../assets/images/icons/ArrowDown.svg"
import editIcon from "../../../assets/images/icons/edit.svg"
import { addSpaceEveryNChars, checkExtension } from "helpers/common"
import { Link } from "react-router-dom"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import imageIcon from "../../../assets/images/icons/image.svg"
import { useSelector } from "react-redux"
import Spinners from "components/Common/Spinner"
import Select, { components } from "react-select"

import { depositories } from "helpers/depositories"
import { reactSelectStyles } from "helpers/utils"

const CustomDropdownIndicator = (props) => {
  const { isDisabled } = props.selectProps

  return (
    <components.DropdownIndicator {...props}>
      {!isDisabled ? <img className="cp" src={ArrowDown} alt="" /> : <></>}
    </components.DropdownIndicator>
  )
}

const IndividualView = ({ profileData }) => {
  const { userType } = useSelector((state) => state.user)
  const [isDisabled, setIsDisabled] = useState(true)

  const politicalExposeOptions = [
    "Not Applicable",
    "Politically Exposed Person",
    "Related to Politically Exposed Person",
  ]

  const getDepositoryParticipantValue = () => {
    const v = profileData?.dematDetails?.depository_participant_name
    return {
      label: v,
      value: v,
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <div>
            <div>
              <Row className="mb-2">
                {profileData?.aadhaarDetails && (
                  <>
                    <div className="d-flex align-items-center mt-4 mb-4 justify-content-between">
                      <CardTitle className="">Personal Details</CardTitle>
                    </div>
                    <Col xl={6}>
                      <Label className="col-form-label">Name</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={profileData?.aadhaarDetails?.name}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Date of Birth</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={profileData?.aadhaarDetails?.dob}
                      />
                    </Col>
                  </>
                )}
                {profileData?.aadhaarDetails && (
                  <Col xl={6}>
                    <Label className="col-form-label">PAN</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={profileData?.panDetails?.pan}
                    />
                  </Col>
                )}

                {profileData?.aadhaarDetails && (
                  <Col xl={6}>
                    <Label className="col-form-label">Aadhaar No.</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={addSpaceEveryNChars(
                        profileData?.aadhaarDetails?.aadhaar_no
                      )}
                    />
                  </Col>
                )}

                {profileData?.additionalDetails && (
                  <Col xl={6}>
                    <Label className="col-form-label">Political Exposure</Label>
                    <div className="input-wrapper">
                      <select
                        disabled={true}
                        id="politicalExposure"
                        name="politicalExposure"
                        className={`form-select pageSize with-icon`}
                        value={
                          profileData?.additionalDetails?.politicalExposure
                        }
                      >
                        <option value="">Select</option>
                        {politicalExposeOptions.map((item, index) => (
                          <option
                            key={`political_exposure_${index}`}
                            value={item}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      {profileData?.bankDetails && (
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Bank Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Account Holders Name
                    </Label>
                    <Input
                      disabled
                      name="account_holder"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.account_holder || ""}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Number</Label>

                    <Input
                      disabled
                      name="account_no"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.account_no || ""}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Bank Name</Label>
                    <Input
                      disabled
                      name="bank_name"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.bank_name || ""}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">IFSC</Label>
                    <Input
                      disabled
                      name="ifsc"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.ifsc || ""}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Type</Label>
                    <Input
                      disabled
                      name="account_type"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.account_type || ""}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {profileData?.dematDetails && (
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Demat Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Demat Account Number
                    </Label>
                    <div className="input-wrapper">
                      <Input
                        innerRef={dematAccNoRef}
                        disabled
                        name="demat_account_no"
                        type="text"
                        className="form-control"
                        value={profileData?.dematDetails?.demat_account_no}
                      />
                      <div
                        onClick={() => (dematAccNoRef.current.disabled = false)}
                      >
                        <img className="cp" src={editIcon} alt="" />
                      </div>
                    </div>
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Depository Participant Name
                    </Label>
                    <div className="input-wrapper">
                      <Select
                        className={isDisabled ? "react-select-disabled" : ""}
                        isDisabled={isDisabled}
                        styles={reactSelectStyles}
                        options={depositories}
                        placeholder="Select Name"
                        value={getDepositoryParticipantValue()}
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                      />
                      {isDisabled && (
                        <div onClick={() => setIsDisabled(false)}>
                          <img className="cp" src={editIcon} alt="" />
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Depository Name</Label>
                    <div className="input-wrapper">
                      <Input
                        name="exchange_type"
                        type="text"
                        className="form-control"
                        disabled
                        value={profileData?.dematDetails.exchange_type}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col xl={12}>
          <CardTitle className="mt-4 mb-4">Documents</CardTitle>
          {profileData?.aadhaarDetails && (
            <>
              <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                Personal KYC
              </CardTitle>
              <div className="documents-section">
                {profileData?.aadhaarDetails?.aadhaar_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        profileData?.aadhaarDetails.aadhaar_file
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Aadhaar</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/aadhaar/${profileData?.aadhaarDetails.aadhaar_file}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
                {profileData?.selfieDetails?.user_image && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.selfieDetails.user_image) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Selfie</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/${
                            userType === "INVESTOR"
                              ? "avatar/investor"
                              : "avatar/wealth"
                          }/${profileData?.selfieDetails.user_image}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
                {profileData?.panDetails?.pan_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.panDetails?.pan_file) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>PAN</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/pan/${profileData?.panDetails.pan_file}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
              </div>
            </>
          )}

          {profileData?.bankDetails && (
            <>
              <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                Banking Documents
              </CardTitle>
              <div className="documents-section">
                {profileData?.dematDetails?.cml_report && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.dematDetails?.cml_report) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>CML Report</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/cml/${profileData?.bankDetails.cml_report}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
                {profileData?.bankDetails?.cheque_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.bankDetails.cheque_file) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Cheque</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/cheques/${profileData?.bankDetails.cheque_file}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
              </div>
            </>
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default IndividualView
